import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/customers',
    name: 'customers',
    component: () => import('../views/CustomersView.vue')
  },
  {
    path: '/customer/:id',
    name: 'customer',
    component: () => import('../views/CustomerSpecificView.vue')
  },
  {
    path: '/tickets',
    name: 'tickets',
    component: () => import('../views/TicketsView.vue')
  },
  {
    path: '/ticket/:id',
    name: 'ticket',
    component: () => import('../views/TicketSpecificView.vue')
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('../views/DevicesView.vue')
  },
  {
    path: '/device/:id',
    name: 'device',
    component: () => import('../views/DeviceSpecificView.vue')
  },
  {
    path: '/alerts',
    name: 'alerts',
    component: () => import('../views/AlertsView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
